import type { CSSProperties, PropsWithChildren } from 'react';
import { VStack } from '~/molecules';
import { ThemeProvider } from 'butlerapp-integration/src/components/Theme';
import { UnistylesRuntime, useUnistyles, StyleSheet } from 'react-native-unistyles';

export function AdminBookingRootContainer({ children }: PropsWithChildren) {
    return <VStack style={styles.root}>{children}</VStack>;
}

export function BookingFormSection({ children }: PropsWithChildren) {
    return <VStack style={styles.section}>{children}</VStack>;
}

export function AdminBookingTheme({ children }: PropsWithChildren) {
    const { theme } = useUnistyles();
    return (
        <ThemeProvider addTheme theme={UnistylesRuntime.themeName === 'dark' ? 'dark' : 'light'}
            style={{
                '--ws-background-color': theme.colors.surface,
                '--ws-background-color-contrast': theme.colors.onSurface,
                color: theme.colors.onSurface,
                fontFamily: theme.typescale.bodyMedium.fontFamily,
                fontSize: theme.typescale.bodyMedium.fontSize,
            } as CSSProperties}>
            {children}
        </ThemeProvider>
    );
}

const styles = StyleSheet.create((theme) => ({
    root: {
        gap: theme.spacings['3'],
        width: '100%',
    },
    section: {
        backgroundColor: theme.colors.surface,
        borderRadius: theme.shapes.corner.small,
        padding: theme.spacings['3'],
        width: '100%',
    },
}));
